
import React, { useEffect, useState } from 'react';
import { indexWrapCss, widthCss } from './css/Home.style';

import HeroSection from './component/Home/HeroSection';
import ActionCardsSection from './component/Home/ActionCardsSection';
import DarkBackgroundSection from './component/Home/DarkBackgroundSection';
import RecommendationSection from './component/Home/RecommendationSection';
import CtaSection from './component/Home/CtaSection';
import Header from "../layouts/header/Header";
import Footer from "../layouts/footer/Footer";
import AuthorStorySection from "./component/Home/AuthorStorySection";
import AuthorSection from "./component/Home/AuthorSection";
import LikeFollowSection from "./component/Home/LikeFollowSection";
import PostCardSection from './component/Home/PostCardSection';
import { useIsMobile } from "../../hooks/useIsMobile";
import { useNavigate } from "react-router-dom";
import PostCardSection_mobile from "./component/Home/PostCardSection_mobile";
import ActionCardsSection_mobile from "./component/Home/ActionCardsSection_mobile";
import AuthorSection_mobile from "./component/Home/AuthorSection_mobile";
import usePageTitle from "../../hooks/usePageTitle";


const Home: React.FC = () => {
    usePageTitle("북밋 - 작가와 독자가 만나는 공간");

    const [search, setSearch] = useState("");

    const onSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };

    const isMobile = useIsMobile();

    const navigate = useNavigate();

    //작가로 시작하기 버튼 클릭 시 리다이렉트
    useEffect(() => {
        const redirectPath = localStorage.getItem("redirectAfterReload");

        if (redirectPath) {

            localStorage.removeItem("redirectAfterReload");

            if (window.location.pathname !== redirectPath) {
                navigate(redirectPath);
            } else {
            }
        }
    }, [navigate]);



    return (
        <div css={indexWrapCss} className="min-w-[320px]">
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag="home"
            />
            <main className={"flex flex-col gap-[100px] md:gap-[60px] "}>
                <HeroSection />
                <AuthorStorySection />

                {isMobile ? (
                    <>
                        <ActionCardsSection_mobile />
                        <AuthorSection_mobile />
                    </>
                ) :

                    (
                        <>
                            <ActionCardsSection />
                            <AuthorSection />
                        </>


                    )
                }

                <DarkBackgroundSection />
                {isMobile ? (

                    <PostCardSection_mobile />
                ) :

                    (
                        <PostCardSection />


                    )
                }

                <LikeFollowSection />
                <CtaSection />

            </main>

            <Footer />
        </div>
    );
};

export default Home;
